export const getTitleMessage = (actionName, contentType) =>
  `Unable to ${actionName} ${contentType}`;

export const getBodyMessage = (actionName, contentType, userName) =>
  `We are unable to ${actionName} your ${contentType} as ${userName} is currently editing. Please try again later or contact ${userName}`;
